import React, { FC } from 'react';

import { useHierarchicalMenu } from 'react-instantsearch-hooks-web';

import HierarchicalMenuList from './HierarchicalMenuList';

/*for some reason in HierarchicalMenu limit param works strange, on category select it returns not only
subcategories related to category (in response, not on view), but all subcategories that have possible response,
that is why limit should be at least number of all subcategories, to avoid subcategory missing in menu
 */
const LIMIT = 100;

interface HierarchicalMenuProps {
  attributes: string[];
}

export const HierarchicalMenu: FC<HierarchicalMenuProps> = ({ attributes }) => {
  const { items, refine } = useHierarchicalMenu({ attributes, limit: LIMIT });

  return <HierarchicalMenuList items={items} refine={refine} isPrimary />;
};

export default HierarchicalMenu;
